
export const NowcastConstants = {
  COMPONENTSOURCEMAPPING : {
    stationwarnings: 'STATION_WARNING_SOURCES',
    cloudcover: 'CLOUD_COVER_SOURCES',
    cloudtemperature: 'CLOUD_TOP_TEMPERATURE_SOURCES',
    radar: 'RADAR_SOURCES',
    districtwarnings:'DISTRICT_WARNING_SOURCES',
    nowcast:'NOWCAST_SOURCES',
    'seamless-view':'SEAMLESS_SOURCES'
    // 'radar-forecast' : 'NOWCAST_SOURCES'
  },
  DISTRICT_WARNING_SOURCES: {
    default: 'Mausam IMD',
    sourceList: [
      {
        sourceName: 'Mausam IMD',
        attributionLink: 'https://mausam.imd.gov.in',
        attributionText: 'IMD',
        link: 'https://mausam.imd.gov.in/imd_latest/contents/districtwisewarnings.php'
      }
    ]
  },
  STATION_WARNING_SOURCES: {
    default: 'Mausam IMD',
    sourceList: [
      {
        sourceName: 'Mausam IMD',
        attributionLink: 'https://mausam.imd.gov.in',
        attributionText: 'IMD',
        link: 'https://mausam.imd.gov.in/imd_latest/contents/stationwise-nowcast-warning.php'
      }
    ]
  },
  CLOUD_COVER_SOURCES: {
    default: 'Rapid IMD',
    sourceList: [
      {
        sourceName: 'Rapid IMD',
        attributionLink: 'https://rapid.imd.gov.in/rapid/',
        attributionText: 'IMD',
        link: 'https://rapid.imd.gov.in/rapid/',
        satellite:':INSAT-3DR Imager TIR2'
      },
      // {
      //   sourceName: 'Weather US',
      //   attributionLink: 'https://weather.us/',
      //   attributionText: 'Weather US',
      //   link: 'https://weather.us/satellite/india/top-alert-15min/20200929-1000z.html'
      // }
    ]
  },
  NOWCAST_SOURCES: {
    default: 'RADAR+CTT',
    sourceList: [
      {
        sourceName: 'RICKEN',
        displayName : 'RICKEN NOWCAST',
        uuid : '00cb31c7-2928-4e6d-adcc-443d478c90d6'
      },
      // {
      //   sourceName: 'RADAR',
      //   displayName : 'RADAR NOWCAST',
      //   uuid : '00cb31c7-2928-4e6d-adcc-443d47898877'
      // },
      {
        sourceName: 'IMD RADAR',
        displayName : 'IMD NOWCAST',
        uuid : '00cb31c7-2928-4e6d-adcc-443d47898877'
      },
      {
        sourceName: 'RADAR+CTT',
        displayName : 'RADAR+CTT',
        uuid : '00cb31c7-2928-4e6d-adcc-443d47898877'
      },
      {
        sourceName: 'CUSTOM',
        displayName : 'CUSTOM',
        uuid : '00cb31c7-2928-4e6d-adcc-443d47898877'
      }
    ]
  },
  CLOUD_TOP_TEMPERATURE_SOURCES: {
    default: 'Rapid IMD',
    sourceList: [
      {
        sourceName: 'Rapid IMD',
        attributionLink: 'https://rapid.imd.gov.in/rapid/',
        attributionText: 'IMD',
        link: 'https://rapid.imd.gov.in/rapid/'
      },
      // {
      //   sourceName: 'Weather US',
      //   attributionLink: 'https://weather.us/',
      //   attributionText: 'Weather US',
      //   link: 'https://weather.us/satellite/india/top-alert-15min/20200929-1000z.html'
      // }
    ]
  },
  RADAR_SOURCES: {
    default: 'Mausam IMD',
    sourceList: [
      {
        sourceName: 'Mausam IMD',
        sourceValue: 'mausamIMD',
        attributionLink: 'https://mausam.imd.gov.in/',
        attributionText: 'IMD',
        link: 'https://mausam.imd.gov.in/imd_latest/contents/index_radar.php'
      },
      {
        sourceName: 'Rain Viewer',
        sourceValue: 'rainViewer',
        attributionLink: 'https://www.rainviewer.com/',
        attributionText: 'Rain Viewer',
        link: 'https://www.rainviewer.com/api.html'
      }
    ]
  },
  SEAMLESS_SOURCES: {
    default: 'Mausam IMD',
    sourceList: [
      {
        sourceName: 'Mausam IMD',
        sourceValue: 'mausamIMD',
        attributionLink: 'https://mausam.imd.gov.in/',
        attributionText: 'IMD',
        link: 'https://mausam.imd.gov.in/imd_latest/contents/index_radar.php'
      },
    ]
  }
};
